import { cn } from '../utils/cn';
import type { SelectOption } from '../types';

interface RadioGroupInputProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: SelectOption[];
  error?: string;
  required?: boolean;
  disabled?: boolean;
  direction?: 'horizontal' | 'vertical';
  className?: string;
}

export default function RadioGroupInput({
  label, name, value, onChange, options, error, required, disabled, direction = 'horizontal', className,
}: RadioGroupInputProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <label className="block text-xs font-medium text-content-secondary">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className={cn('flex gap-4', direction === 'vertical' && 'flex-col gap-2')}>
        {options.map((opt) => (
          <label key={opt.value} className={cn('flex items-center gap-2 cursor-pointer', disabled && 'opacity-50 cursor-not-allowed')}>
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={onChange}
              disabled={disabled}
              className="h-4 w-4 border-border text-primary focus:ring-primary accent-primary"
            />
            <span className="text-sm text-content-secondary">{opt.label}</span>
          </label>
        ))}
      </div>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}
